import {
  sessionBreadcrumbs,
  sessionsBreadcrumbs,
} from '@/views/sessions/routeBreadcrumbs'

function lazyLoad(view) {
  return () => import(`./${view}.vue`)
}

export default {
  path: 'sessions',
  component: lazyLoad('SessionsRoot'),
  props: true,
  meta: {
    breadcrumbs: sessionsBreadcrumbs,
  },
  redirect: './',
  children: [
    {
      name: 'SessionsView',
      path: '',
      component: lazyLoad('SessionsView'),
      props: true,
    },
    {
      path: ':sessionId',
      component: lazyLoad('SessionRoot'),
      props: true,
      meta: {
        breadcrumbs: sessionBreadcrumbs,
      },
      redirect: './',
      children: [
        {
          path: '',
          name: 'SessionPortal',
          component: lazyLoad('SessionPortal'),
          props: true,
        },
        {
          path: 'bibliography',
          name: 'SessionBibliographyView',
          component: lazyLoad('SessionBibliographyView'),
          props: true,
        },
        {
          path: 'data',
          name: 'SessionDataView',
          component: lazyLoad('SessionDataView'),
          props: true,
        },
      ],
    },
  ],
}
